import { __assign } from "tslib";
import { translate } from "./gettext";
import { createInterpolatorWithNumberFormat, interpolateString, } from "./interpolators";
export var t = function (catalogs, locale) { return function (message, scope, context) {
    if (scope === void 0) { scope = {}; }
    var translated = translate(catalogs, locale, message, context);
    return interpolateString(translated, scope);
}; };
export var tn = function (catalogs, locale) { return function (message, messagePlural, count, scope, context) {
    if (scope === void 0) { scope = {}; }
    var translated = translate(catalogs, locale, message, context, messagePlural, count);
    return interpolateString(translated, __assign(__assign({}, scope), { count: count }));
}; };
export var tf = function (catalogs, locale) {
    var interpolate = createInterpolatorWithNumberFormat(locale);
    return function (message, scope, context, formatOptions) {
        if (scope === void 0) { scope = {}; }
        var translated = translate(catalogs, locale, message, context);
        return interpolate(translated, scope, formatOptions);
    };
};
export var tnf = function (catalogs, locale) {
    var interpolate = createInterpolatorWithNumberFormat(locale);
    return function (message, messagePlural, count, scope, context, formatOptions) {
        if (scope === void 0) { scope = {}; }
        var translated = message || messagePlural
            ? translate(catalogs, locale, message, context, messagePlural, count)
            : "{{ count }}";
        return interpolate(translated, __assign(__assign({}, scope), { count: count }), formatOptions);
    };
};
//# sourceMappingURL=translators.js.map